import React, {useState} from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';

import ChatBot from 'react-simple-chatbot';

import DebugService from '../../services/DebugService';
import I18nService from '../../services/I18nService';
import config from '../../configs';
import {DEFAULT_STEPS} from '../../ReactSimpleChat/config/steps';
import theme, {inputStyle,customStyle} from '../../ReactSimpleChat/config/theme';
import CustomHeader from '../../ReactSimpleChat/customComponents/CustomHeader';

const USE_CACHE = !!process.env.REACT_APP_USE_CACHE && process.env.REACT_APP_USE_CACHE === 'true';


ReactSimpleChatComponent.propTypes = {
  globalKey: PropTypes.string,
};

function ReactSimpleChatComponent({globalKey}) {

  /** Ouverture au chargement */
  const initOpen = USE_CACHE ? (localStorage.getItem(config.CACHE_VAR+'_opened') || false) : false;
  /** Mode d'affichage au chargement */
  const initMode = USE_CACHE ? (localStorage.getItem(config.CACHE_VAR+'_mode') || 'default') : 'default';

  const [opened, setOpened] = useState(initOpen);  // false (default), true
  const [expand, setExpand] = useState(initMode);  // default, mid, full

  const gecko = config.BOSTIK_AVATAR;

  // i18n service
  const myI18nService = I18nService.getInstance();

  // console.log('App - use cache',{USE_CACHE});
  // console.log('App - state',{flow:props.flow});

  /**
   * Change le mode d'ouverture et le conserve en localStorage si cache actif
   */
  const toggleMode = () => {
    if (expand === 'mid'){
      if (USE_CACHE) {
        localStorage.setItem(config.CACHE_VAR+'_mode','full');
      }
      setExpand('full');
    }else if(expand === 'full'){
      if (USE_CACHE) {
        localStorage.setItem(config.CACHE_VAR+'_mode','default');
      }
      setExpand('default');
    }else{
      if (USE_CACHE) {
        localStorage.setItem(config.CACHE_VAR+'_mode','mid');
      }
      setExpand('mid');
    }
  };

  /**
   * Stocke en localStorage, si cache actif, l'etat de l'encart
   * @param {boolean} v
   */
  const handleOpen = (v) => {
    if (USE_CACHE) {
      localStorage.setItem(config.CACHE_VAR+'_opened',v.opened);
      if (DebugService.getInstance().enabled) console.log('ReactSimpleChatComponent - handleOpen',v);
    }
    setOpened(v);
  };

  const Header = (
    <CustomHeader
      headerTitle={myI18nService.t('label.title')}
      floating={true}
      expand={expand}
      toggleChatBot={(v) => handleOpen(v)}
      toggleMode={toggleMode} />
  );

  return (
    <ThemeProvider theme={theme}>
      <ChatBot
        key={globalKey}
        headerTitle={myI18nService.t('label.title')}
        placeholder={myI18nService.t('label.input.placeholder')}
        floating={true}
        opened={opened}
        toggleFloating={handleOpen}
        steps={DEFAULT_STEPS}
        cache={USE_CACHE}
        cacheName={config.CACHE_VAR}
        recognitionEnable={false}
        speechSynthesis={{ enable: false, lang: myI18nService.locale }}
        botAvatar={gecko}
        className={!!expand ? 'expand-'+expand : ''}
        headerComponent={Header}
        inputStyle={inputStyle}
        customStyle={customStyle}
      />
    </ThemeProvider>
  );
}

export default ReactSimpleChatComponent;
